module.exports = __webpack_public_path__ + "img/icn_check_chakui.bcdc534e.png";